export default __webpack_public_path__ + "static/media/step-14.a6012860.png";